/**
 * School grade levels for `user.schoolClass` (stored as text).
 * Keep the values in sync with SCHOOL_CLASS_VALUES in `@package/drizzle` (auth/types.ts).
 */
export const SCHOOL_GRADE_OPTIONS = [
  { value: 'kelas_0', label: 'Kelas 0' },
  { value: 'kelas_1', label: 'Kelas 1' },
  { value: 'kelas_2', label: 'Kelas 2' },
  { value: 'kelas_3', label: 'Kelas 3' },
  { value: 'kelas_4', label: 'Kelas 4' },
  { value: 'kelas_5', label: 'Kelas 5' },
  { value: 'kelas_6', label: 'Kelas 6' },
] as const

export type SchoolGrade = (typeof SCHOOL_GRADE_OPTIONS)[number]['value']

/** Human-readable label for a stored grade value (e.g. `kelas_1` → `Kelas 1`). Returns null for unknown/empty. */
export const schoolGradeLabel = (value: string | null | undefined): string | null =>
  SCHOOL_GRADE_OPTIONS.find((option) => option.value === value)?.label ?? null
